import { _defineProperty } from "@slyte/core/src/lyte-utils";
import { Route } from "../../../node_modules/@slyte/router/index.js";
let FileuploadComp;

class Fileupload extends Route {
  render() {
    return { outlet: '#zcatcomponent', component: FileuploadComp };
  }

  static actions(arg1) {
    return Object.assign(super.actions({}), arg1);
  }

  _() {
    _;
  }

  getRequirements() {
    arguments[1].push(import(
      /* webpackChunkName: "components/javascript/zcat-components/fileupload-comp" */
      "../../../components/javascript/zcat-components/fileupload-comp"
    ).then(function(res) {
      FileuploadComp = res.FileuploadComp;
    }));

    
;
  }
}

export { Fileupload };
